import { useContext } from 'react'
import { conceptsPropertyContext } from '../../../pages/chaloupka/concepts'
import { PropertySearchForm } from './PropertySearchForm'

export const ConceptsPropertySearch = () => {
  const { updateFilter, filter } = useContext(conceptsPropertyContext)

  return (
    <PropertySearchForm
      filter={filter}
      onSubmit={updateFilter}
      listType='opened'
    />
  )
}
